import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  selector: '[app-root]',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private config = inject(NgSelectConfig);

  title = 'eluci';

  constructor() {
    this.config.placeholder = 'Select some value';
    this.config.notFoundText = 'Value can not be found';
    this.config.typeToSearchText = 'Start typing to search';
    this.config.bindLabel = 'label';
    this.config.bindValue = 'value';
  }
}
